
import WidgetsIcon from '@mui/icons-material/Widgets';
import CropFreeIcon from '@mui/icons-material/CropFree';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

import WarehouseIcon from '@mui/icons-material/Warehouse';

export const spOrderDetailsConfigContent = {
   
    // status: {
    //     title: 'status',
    //     icon: <WarehouseIcon/>,
    // },
    summaryRelation: {
        title: 'summary',
        icon: <CropFreeIcon/>,
    },
    summary: {
        title: 'summary',
        icon: <CropFreeIcon/>,
    },
    pickingLines: {
        title: 'pickinglines',
        icon: <WidgetsIcon/>,
        isSingleDataGrid: true,
    },
    spReplenish: {
        title: 'replenish',
        icon: <WidgetsIcon/>,
        isSingleDataGrid: true,
    },
    shipOrder: {
        title: 'ship_order',
        icon: <CropFreeIcon/>,
        options : [],
    },

    writeOffs: {
        title: 'write_offs',
        icon: <CropFreeIcon/>,
    },
    spShipments:  {
        title: "sp_shipments",
        icon: <WidgetsIcon/>,
    }, 
    jokers: {
        title: "jokers",
        icon: <WidgetsIcon/>,
    },
    spLogs: {
        title: 'logs',
        icon: <FormatListBulletedIcon/>,
        isSingleDataGrid: true,
    },
};

export const spOrderDetailsConfig = (relation) => {
    if (relation) {
        return {
            summaryRelation: spOrderDetailsConfigContent.summaryRelation,
            shipOrder: spOrderDetailsConfigContent.shipOrder,
            spShipments: spOrderDetailsConfigContent.spShipments,
        };
    }
    return {
        summary: spOrderDetailsConfigContent.summary,
        pickingLines: spOrderDetailsConfigContent.pickingLines,
        shipOrder: spOrderDetailsConfigContent.shipOrder,
        spShipments: spOrderDetailsConfigContent.spShipments,
    };
}